module.exports = __webpack_public_path__ + "img/bilibili.aa16a616.png";